module.exports = __webpack_public_path__ + "static/img/hdxz.8ba5b33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hdxz.png
// module id = yojr
// module chunks = 2